import {
    REGISTER_WIZARD_ROUTES,
    REGISTER_TYPES,
    MY_PERMISSIONS,
    REGISTERS_PERMISSIONS
} from '@/constants'
import { myPermissionsGuard } from '@src/router/guards'

export default {
    name: REGISTER_WIZARD_ROUTES.INCIDENTS.INDEX.name,
    component: () => import('@/containers/RegisterWizard/RegisterOfIncidents'),
    path: 'incidents',
    props: true,
    redirect: to => ({
        name: REGISTER_WIZARD_ROUTES.INCIDENTS.WIZARD.name,
        params: { ...to.params }
    }),
    meta: {
        requiresAuth: true,
        register: REGISTER_TYPES.INCIDENTS
    },
    children: [
        {
            path: 'wizard',
            name: REGISTER_WIZARD_ROUTES.INCIDENTS.WIZARD.name,
            component: () =>
                import('@/components/registers/incidents/WizardTab'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INCIDENTS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INCIDENTS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INCIDENT_REGISTER_ACCESS,
                    REGISTERS_PERMISSIONS.INCIDENT_REGISTER
                ]
            }
        },
        {
            path: 'properties',
            name: REGISTER_WIZARD_ROUTES.INCIDENTS.PROPERTIES.name,
            component: () => import('@/components/registers/PropertiesTab'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INCIDENTS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INCIDENTS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INCIDENT_REGISTER_ACCESS,
                    REGISTERS_PERMISSIONS.INCIDENT_REGISTER
                ]
            }
        },
        {
            path: 'discussions',
            name: REGISTER_WIZARD_ROUTES.INCIDENTS.DISCUSSIONS.name,
            component: () => import('@/components/registers/Discussions'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INCIDENTS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INCIDENTS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INCIDENT_REGISTER_ACCESS,
                    REGISTERS_PERMISSIONS.INCIDENT_REGISTER
                ]
            }
        }
    ]
}
